import React, { FC } from 'react';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import MediaShowPage, {
  MediaTypes
} from '@buyside/components/presentation/MediaShowPage/mediaShowPage';

const PodcastEpisodeShowPageRoot: FC<{ podcastEpisodeId: string }> = ({ podcastEpisodeId }) => {
  if (!podcastEpisodeId) return;

  return (
    <ErrorBoundary pageName="the podcast episode page">
      <MediaShowPage id={podcastEpisodeId} mediaType={MediaTypes.PODCAST_EPISODE} />
    </ErrorBoundary>
  );
};

export default PodcastEpisodeShowPageRoot;
